module.exports = __webpack_public_path__ + "img/speed-1.0f110dce.png";